import React from 'react';

const ActiveNavTriangleClipPath = (props)=>{
    return React.createElement("svg", {
        viewBox: "0 0 22 7",
        width: "0",
        height: "0"
    }, React.createElement("defs", null, React.createElement("clipPath", {
        id: "activeNavClipPath"
    }, React.createElement("path", {
        d: "M7,0.6c0.8-0.8,2.1-0.8,3,0l3.2,3c0,0,1.5,1.4,2.5,1.4S-2,5,0.2,5c2.2,0,3.7-1.4,3.7-1.4L7,0.6z"
    }))));
};
const CaretSVG = (props)=>{
    return React.createElement("svg", {
        ...props,
        width: "11",
        height: "10",
        viewBox: "0 0 11 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
        d: "M9.5093 2.99758L5.25149 7.25521L1.00631 2.99758",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};

export { ActiveNavTriangleClipPath, CaretSVG };
